module.exports = __webpack_public_path__ + "static/media/korhn_kolinsky_solmonte.b7a47134.jpg";